import {
    DELETEBUSINESSNATUREMAPPING_SUCCESS,
    DELETEBUSINESSNATUREMAPPING_FAILED,
    RESET_DELETEBUSINESSNATUREMAPPING,
    LOADING_DELETEBUSINESSNATUREMAPPING,
    NETWORK_ERROR_DELETEBUSINESSNATUREMAPPING,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DELETEBUSINESSNATUREMAPPING:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case DELETEBUSINESSNATUREMAPPING_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case DELETEBUSINESSNATUREMAPPING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_DELETEBUSINESSNATUREMAPPING:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_DELETEBUSINESSNATUREMAPPING:
            return (state = initialState);
        default:
            return state;
    }
};
